import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { useTranslation } from 'react-i18next';
import { dataActionCreators, ProjectAssigment } from '../../store/Data';
import { UserLoginState } from '../../store/Login';
import { DataHelpers } from '../../DataHelpers';
import { useMsal } from '@azure/msal-react';
import { TeamsState } from '../../store/TeamsState';
import { TokenHelper } from '../../TokenHelper';
import { Button, MessageBar, MessageBarBody, Text } from '@fluentui/react-components';
import { Dismiss24Filled, Edit24Filled, ArrowUpload24Filled } from "@fluentui/react-icons";
import { useQuickViewStyles } from '../Styles/QuickView';
import { DownloadSPOLinkAndNav } from '../Tools/FileDownloadHelper';
import { SharePointSVG } from '../Resources/SharePointSVG';
import { useTimeSheetEntries } from '../Tools/ObjectLoader';

export const ProjectsAssigmentsQuickView = () => {
    const projectAssigmentQuickView = useSelector<ApplicationState, ProjectAssigment | null>((state: ApplicationState) => state.data.projectAssigmentQuickView);
    const { timeSheetEntries } = useTimeSheetEntries();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const viewDebugInfo = useSelector((state: ApplicationState) => state.userNeomyticLogin.viewDebugInfo);
    const UserLoginState = useSelector<ApplicationState, UserLoginState>((state: ApplicationState) => state.userNeomyticLogin);
    const { instance } = useMsal();
    const teamsState = useSelector<ApplicationState, TeamsState>((state: ApplicationState) => state.teamsState);
    const [poUsedQuantity, setpoUsedQuantity] = React.useState<number | undefined>(undefined);
    const styles = useQuickViewStyles();

    React.useEffect(() => {
        if (projectAssigmentQuickView !== null && timeSheetEntries !== undefined) {
            setpoUsedQuantity(DataHelpers.ProjectAssigmentCompletedQuantity(projectAssigmentQuickView, timeSheetEntries));
        }
    }, [timeSheetEntries, projectAssigmentQuickView]);

    const getPriceTypeSelectionString = (s: string): string => {
        switch (s) {
            case "H": return t('Hours');
            case "D": return t('Days');
            case "M": return t('Month');
            case "F": return t('Fixed');
        }
        return "Unknown";
    };

    if (projectAssigmentQuickView) {
        return (
            <div className={styles.root} >
                <div className={styles.titleAndOps}>
                    <h2>{"Project assigment : " + (projectAssigmentQuickView.displayName ? projectAssigmentQuickView.displayName : "?")}</h2>
                    <div className={styles.titleAndOpsButtons}>
                        {UserLoginState && UserLoginState.rigths && UserLoginState.rigths.isAdmin && <Button icon={<Edit24Filled />} shape="circular" title={t('Edit')} onClick={() => dispatch(dataActionCreators.requestProjectAssigmentEdition(projectAssigmentQuickView))} />}
                        <Button icon={<Dismiss24Filled />} shape="circular" title="Close" onClick={() => dispatch(dataActionCreators.requestClearQuickView())} />
                    </div>
                </div>
                {viewDebugInfo &&
                    <>
                        <h2>Id</h2>
                        <Text truncate>{projectAssigmentQuickView.projectAssignmentid}</Text>
                    </>
                }
                {(UserLoginState && UserLoginState.rigths && UserLoginState.rigths.isAdmin) && <>
                    <h2>Consultant Code</h2>
                    <Text truncate>{projectAssigmentQuickView.consultantCode ? projectAssigmentQuickView.consultantCode : t('NotDefined')}</Text>
                    <h2>PO Doc</h2>
                    <div className={styles.InlineRow}>
                        {projectAssigmentQuickView.orderSharePointFileUniqueId
                            ? <>
                                <Button shape="circular" title={t('ViewInSharePoint')} icon={<SharePointSVG />}
                                    onClick={() => {
                                        TokenHelper.GetToken(instance, teamsState)
                                            .then(token => {
                                                if (token !== null && projectAssigmentQuickView.projectAssignmentid) {
                                                    DownloadSPOLinkAndNav('api/ProjectsAssigments/' + projectAssigmentQuickView.projectAssignmentid + "/DownloadSPOLink", token);
                                                }
                                            });
                                    }
                                    } />
                            </>
                            : <MessageBar intent="warning">
                                <MessageBarBody>
                                    {t('Missing')}
                                </MessageBarBody>
                            </MessageBar>
                        }
                        <Button icon={<ArrowUpload24Filled />} shape="circular" title="Upload" onClick={() => dispatch(dataActionCreators.requestFileUploadProjectAssigment(projectAssigmentQuickView))} />
                    </div>
                </>
                }
                {projectAssigmentQuickView.po && <><h2>PO</h2><Text truncate>{projectAssigmentQuickView.po}</Text></>}
                <h2>{t('Start')}</h2>
                <Text truncate>{projectAssigmentQuickView.dateDebut ? new Date(projectAssigmentQuickView.dateDebut).toLocaleDateString() : t('NotDefined')}</Text>
                <h2>{t('End')}</h2>
                <Text truncate>{projectAssigmentQuickView.dateFin ? new Date(projectAssigmentQuickView.dateFin).toLocaleDateString() : t('NotDefined')}</Text>
                {UserLoginState && UserLoginState.rigths && UserLoginState.rigths.isAdmin && <>
                    <h2>{t('CustomerPrice')}</h2>
                    <Text truncate>{projectAssigmentQuickView.customerPrice.toLocaleString(undefined, { style: 'currency', currency: 'EUR' }) + " / " + getPriceTypeSelectionString(projectAssigmentQuickView.unitOfTime)}</Text>
                </>}
                <h2>{t('ConsultantPrice')}</h2>
                <Text truncate>{projectAssigmentQuickView.consultantPrice.toLocaleString(undefined, { style: 'currency', currency: 'EUR' }) + " / " + getPriceTypeSelectionString(projectAssigmentQuickView.unitOfTime)}</Text>
                {projectAssigmentQuickView.description && <>
                    <h2>Description</h2>
                    <pre style={{ whiteSpace: "pre-wrap" }}>{projectAssigmentQuickView.description}</pre>
                </>}
                {UserLoginState && UserLoginState.rigths && UserLoginState.rigths.isAdmin && <>
                    <h2>{t('Worked')}</h2>
                    {projectAssigmentQuickView.poquantity !== null
                        ? <Text truncate>{poUsedQuantity != undefined ? (poUsedQuantity + " / " + projectAssigmentQuickView.poquantity + " " + getPriceTypeSelectionString(projectAssigmentQuickView.unitOfTime)) : "Loading..."}</Text>
                        : <Text truncate>{poUsedQuantity != undefined ? (poUsedQuantity + " " + getPriceTypeSelectionString(projectAssigmentQuickView.unitOfTime)) : "Loading..."}</Text>
                    }
                </>}
            </div>
        );
    }
    return null;
};